/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createStudent = /* GraphQL */ `
  mutation CreateStudent(
    $input: CreateCustomEntityInput!
    $password: String!
    $sId: ID
  ) {
    createStudent(input: $input, password: $password, sId: $sId) {
      success {
        email
        id
      }
      failure {
        name
        message
        technicals
      }
    }
  }
`;
export const createTeacher = /* GraphQL */ `
  mutation CreateTeacher(
    $input: CreateCustomEntityInput!
    $password: String!
    $sId: ID
  ) {
    createTeacher(input: $input, password: $password, sId: $sId) {
      success {
        email
        id
      }
      failure {
        name
        message
        technicals
      }
    }
  }
`;
export const updateLoginUser = /* GraphQL */ `
  mutation UpdateLoginUser($id: ID!, $email: String, $password: String) {
    updateLoginUser(id: $id, email: $email, password: $password) {
      success
      failure {
        name
        message
        technicals
      }
    }
  }
`;
export const updateTeacher = /* GraphQL */ `
  mutation UpdateTeacher($input: UpdateCustomEntityInput!) {
    updateTeacher(input: $input) {
      id
      sId
      eData {
        sch {
          name
          isCurrentSubscriber
        }
        tch {
          firstName
          lastName
          email
          isAdmin
        }
        stu {
          firstName
          lastName
          email
          cohort
          group
          schId
        }
      }
      hstry {
        items {
          id
          qGId
          fTId
          tsS
          tsF
          aId
          wsT
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateStudent = /* GraphQL */ `
  mutation UpdateStudent($input: UpdateCustomEntityInput!) {
    updateStudent(input: $input) {
      id
      sId
      eData {
        sch {
          name
          isCurrentSubscriber
        }
        tch {
          firstName
          lastName
          email
          isAdmin
        }
        stu {
          firstName
          lastName
          email
          cohort
          group
          schId
        }
      }
      hstry {
        items {
          id
          qGId
          fTId
          tsS
          tsF
          aId
          wsT
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteLoginUser = /* GraphQL */ `
  mutation DeleteLoginUser($id: ID!) {
    deleteLoginUser(id: $id) {
      success
      failure {
        name
        message
        technicals
      }
    }
  }
`;
export const deleteStudentHistory = /* GraphQL */ `
  mutation DeleteStudentHistory($id: ID!) {
    deleteStudentHistory(id: $id) {
      success
      failure {
        name
        message
        technicals
      }
    }
  }
`;
export const createQuestionGroup = /* GraphQL */ `
  mutation CreateQuestionGroup($input: CreateQuestionGroupInput!) {
    createQuestionGroup(input: $input) {
      id
      qGId
      fTId
      tsS
      tsF
      aId
      wsT
      qs {
        a {
          mc
          sa
        }
        qId
        r
        isMkd
        it {
          ttl
          vId
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteQuestionGroup = /* GraphQL */ `
  mutation DeleteQuestionGroup($input: DeleteQuestionGroupInput!) {
    deleteQuestionGroup(input: $input) {
      id
      qGId
      fTId
      tsS
      tsF
      aId
      wsT
      qs {
        a {
          mc
          sa
        }
        qId
        r
        isMkd
        it {
          ttl
          vId
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const createEntity = /* GraphQL */ `
  mutation CreateEntity($input: CreateEntityInput!) {
    createEntity(input: $input) {
      id
      sId
      eData {
        sch {
          name
          isCurrentSubscriber
        }
        tch {
          firstName
          lastName
          email
          isAdmin
        }
        stu {
          firstName
          lastName
          email
          cohort
          group
          schId
        }
      }
      hstry {
        items {
          id
          qGId
          fTId
          tsS
          tsF
          aId
          wsT
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateEntity = /* GraphQL */ `
  mutation UpdateEntity($input: UpdateEntityInput!) {
    updateEntity(input: $input) {
      id
      sId
      eData {
        sch {
          name
          isCurrentSubscriber
        }
        tch {
          firstName
          lastName
          email
          isAdmin
        }
        stu {
          firstName
          lastName
          email
          cohort
          group
          schId
        }
      }
      hstry {
        items {
          id
          qGId
          fTId
          tsS
          tsF
          aId
          wsT
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteEntity = /* GraphQL */ `
  mutation DeleteEntity($input: DeleteEntityInput!) {
    deleteEntity(input: $input) {
      id
      sId
      eData {
        sch {
          name
          isCurrentSubscriber
        }
        tch {
          firstName
          lastName
          email
          isAdmin
        }
        stu {
          firstName
          lastName
          email
          cohort
          group
          schId
        }
      }
      hstry {
        items {
          id
          qGId
          fTId
          tsS
          tsF
          aId
          wsT
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
